/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Corporate } from '../../models/corporate';
import { CorporateApiRespModel } from '../../models/corporate-api-resp-model';

export interface ApiMasterCorporateEditPost$Params {
      body?: Corporate
}

export function apiMasterCorporateEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterCorporateEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCorporateEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CorporateApiRespModel>;
    })
  );
}

apiMasterCorporateEditPost.PATH = '/api/Master/Corporate/Edit';
